import React from 'react'
import PropTypes from 'prop-types'
import { BlockContent, BlockHeader, BlockWrapper } from '../common'

/**
 * A simple block with default styles (background, border, radius, padding....)
 */
const Block = ({
  loading,
  title,
  color,
  toolbar,
  headerProps,
  contentProps,
  scrollable,
  children,
  padding,
  icon,
  ...domProps
}) => {
  const hasHeader = Boolean(title || toolbar)
  return (
    <BlockWrapper {...domProps} layout={hasHeader ? 'auto 1' : ''} gap="0">
      {hasHeader && (
        <BlockHeader title={title} color={color} toolbar={!loading ? toolbar : null} icon={icon} {...headerProps} />
      )}
      <BlockContent loading={loading} padding={padding} scrollable={scrollable} {...contentProps}>
        {children}
      </BlockContent>
    </BlockWrapper>
  )
}

Block.defaultProps = {
  contentProps: {},
}

Block.propTypes = {
  /**
   * Whether the block is busy loading some content.
   */
  loading: PropTypes.bool,
  /**
   * The title to display in the block header.
   */
  title: PropTypes.node,
  /**
   * A toolbar node in the block header.
   */
  toolbar: PropTypes.node,
  /**
   * Props to apply to the block header.
   */
  headerProps: PropTypes.object,
  /**
   * props to apply to the block content.
   */
  contentProps: PropTypes.object,
  /**
   * Whether the block should scroll if its content doesn't fit.
   */
  scrollable: PropTypes.bool,
  /**
   * The children of the block.
   */
  children: PropTypes.node,
  /**
   * The icon of the block to place in the header.
   */
  icon: PropTypes.elementType,
  /**
   * The title color.
   */
  color: PropTypes.string,
  /**
   * The block content padding.
   */
  padding: PropTypes.string,
}

export default Block
